import PropTypes from 'prop-types';
import * as React from 'react';

import { connectSearchBox } from 'react-instantsearch-dom';

const SearchBox = connectSearchBox(
  ({ currentRefinement, refine, className }) => (
    <form noValidate action="" role="search" className="flex items-center">
      <input
        placeholder="Search"
        type="search"
        value={currentRefinement}
        onChange={(event) => refine(event.currentTarget.value)}
        className={className}
      />
    </form>
  )
);

SearchBox.propTypes = {
  currentRefinement: PropTypes.string,
  className: PropTypes.string,
  refine: PropTypes.func,
};

export { SearchBox };
